// src/sections/CheckScontrino.jsx
import React, { useState, useEffect } from "react";
import { fetchListPuntiVendita } from "../utilis/apiService";
import { postVendita } from "../utilis/apiSend";
import GridEstrazioni from '../components/GridEstrazioni'
import PrimoPrezzo from '../img/PrimoPrezzo.png'

const CheckScontrino = ({ contenuti }) => {
  // 1) Lista PV
  const [pvList, setPvList] = useState([]);
  const [loadingPv, setLoadingPv] = useState(true);
  const [errorPv, setErrorPv] = useState(null);

  // 2) PV selezionato
  const [selectedPv, setSelectedPv] = useState("");

  // 3) Risultati estrazioni
  const [estrazioni, setEstrazioni] = useState([]);
  const [loadingEst, setLoadingEst] = useState(false);
  const [errorEst, setErrorEst] = useState(null);

  const currentPv = pvList.find(pv => String(pv.ID) === String(selectedPv));
  const displayAddress = currentPv
    ? `${currentPv.indirizzo}, ${currentPv.citta}`
    : "";

  // testo intro dal JSON
  const first = Array.isArray(contenuti)
    ? contenuti[0]
    : Object.values(contenuti)[0];
  const { sottotitolo_it, descrizione_it } = first;

  // Carico PV all’avvio
  useEffect(() => {
    fetchListPuntiVendita()
      .then(data => setPvList(data))
      .catch(err => { console.error(err); setErrorPv("Non riesco a caricare i punti vendita"); })
      .finally(() => setLoadingPv(false));
  }, []);


  useEffect(() => {
    if (!selectedPv) return setEstrazioni([]);
    setLoadingEst(true);
    setErrorEst(null);
    postVendita(selectedPv)
      .then(data => setEstrazioni(data))
      .catch(err => { console.error(err); setErrorEst("Errore recupero estrazioni"); })
      .finally(() => setLoadingEst(false));
  }, [selectedPv]);



  // Handler per il pulsante
  const handleCheck = () => {
    if (!selectedPv) return;
    setLoadingEst(true);
    setErrorEst(null);
    postVendita(selectedPv)
      .then(data => setEstrazioni(data))
      .catch(err => { console.error(err); setErrorEst("Errore recupero estrazioni"); })
      .finally(() => setLoadingEst(false));
  };

  return (
    <section style={{ marginBottom: 100, padding: '64px 0'  }}>
      <div className="container">
        {/* Intro */}
        <div className="row text-center mb-3">
          <span className="col-12 text-16">
            {sottotitolo_it}
          </span>
        </div>
        <div className="row text-center mb-4">
          <h4 className="col-12 text-18 fw-bold">
            {descrizione_it}
          </h4>
        </div>
        {/* Select + Button */}
        <div className="row g-2 mb-5 justify-content-center">
          <div className="col-12 col-md-6 ">
            {loadingPv
              ? <p>Caricamento punti vendita…</p>
              : errorPv
                ? <p className="text-danger">{errorPv}</p>
                : (
                  <select
                    className="form-select py-2"
                    value={selectedPv}
                    onChange={e => setSelectedPv(e.target.value)}
                  >
                    <option value="">Seleziona il punto vendita</option>
                    {pvList.map(pv => (
                      <option key={pv.ID} value={pv.ID}>
                        {pv.citta} – {pv.indirizzo}
                      </option>
                    ))}
                  </select>
                )
            }
          </div>
          {/* <div className="col-md-6">
            <button
              className="bg-card-evidence border-radius-4 text-white pointer w-100"
              style={{ height: 40 }}
              disabled={!selectedPv || loadingEst}
            >
              SCOPRI SE HAI VINTO
            </button>
          </div> */}
        </div>

        {/* Tabella risultati */}
        {!errorEst && Object.keys(estrazioni).length > 0 && (
          <div>
            <div className="d-flex align-items-center">
              <div className="d-inline-block">
                <figure>
                  <img
                    src={PrimoPrezzo}
                    alt="Logo Primo Prezzo"
                    style={{ maxWidth: "200px", height: "auto" }}
                  />
                </figure>
              </div>
              {displayAddress && (
                <h2 className="d-inline">
                  {displayAddress}
                </h2>
              )}
            </div>
            <div className="accordion" id="accordionEstrazioni">
              {Object.entries(estrazioni).map(([data, tickets], idx) => (
                <GridEstrazioni
                  idx={idx}
                  data={data}
                  tickets={tickets}
                />
              ))}
            </div>
          </div>
        )}

        {/* Se non ci sono risultati ma ho già fatto una verifica */}
        {!loadingEst &&
          !errorEst &&
          selectedPv &&
          estrazioni.length === 0 && (
            <p>Nessuna estrazione trovata per questo punto vendita.</p>
          )}
      </div>
    </section>
  );
};

export default CheckScontrino;
